"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _DatResponse = _interopRequireDefault(require("../model/DatResponse"));
var _EquipmentType = _interopRequireDefault(require("../model/EquipmentType"));
var _LaneSchema = _interopRequireDefault(require("../model/LaneSchema"));
var _RateType = _interopRequireDefault(require("../model/RateType"));
var _SavedLaneListResponse = _interopRequireDefault(require("../model/SavedLaneListResponse"));
var _SavedLaneSchema = _interopRequireDefault(require("../model/SavedLaneSchema"));
var _ShipwellApiErrorResponse = _interopRequireDefault(require("../model/ShipwellApiErrorResponse"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * Shipwell Pricing API
                                                                                                                                                                                                                                                                                                                                                                                               * Historical & forecasted shipping lane price data, at your fingertips.
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               * The version of the OpenAPI document: 0.9.1
                                                                                                                                                                                                                                                                                                                                                                                               * 
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
                                                                                                                                                                                                                                                                                                                                                                                               * https://openapi-generator.tech
                                                                                                                                                                                                                                                                                                                                                                                               * Do not edit the class manually.
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               */
/**
* Default service.
* @module api/DefaultApi
* @version 0.9.1
*/
var DefaultApi = /*#__PURE__*/function () {
  /**
  * Constructs a new DefaultApi. 
  * @alias module:api/DefaultApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function DefaultApi(apiClient) {
    _classCallCheck(this, DefaultApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Callback function to receive the result of the createLaneLanesPost operation.
   * @callback module:api/DefaultApi~createLaneLanesPostCallback
   * @param {String} error Error message, if any.
   * @param {module:model/LaneSchema} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Create Lane
   * @param {Object} opts Optional parameters
   * @param {module:model/LaneSchema} [laneSchema] 
   * @param {module:api/DefaultApi~createLaneLanesPostCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/LaneSchema}
   */
  _createClass(DefaultApi, [{
    key: "createLaneLanesPost",
    value: function createLaneLanesPost(opts, callback) {
      opts = opts || {};
      var postBody = opts['laneSchema'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _LaneSchema["default"];
      return this.apiClient.callApi('/lanes', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the createLaneSavedLanesPost operation.
     * @callback module:api/DefaultApi~createLaneSavedLanesPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SavedLaneSchema} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create Lane
     * @param {Object} opts Optional parameters
     * @param {module:model/SavedLaneSchema} [savedLaneSchema] 
     * @param {module:api/DefaultApi~createLaneSavedLanesPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SavedLaneSchema}
     */
  }, {
    key: "createLaneSavedLanesPost",
    value: function createLaneSavedLanesPost(opts, callback) {
      opts = opts || {};
      var postBody = opts['savedLaneSchema'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _SavedLaneSchema["default"];
      return this.apiClient.callApi('/saved_lanes', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the deleteSavedLaneSavedLanesSavedLaneIdDelete operation.
     * @callback module:api/DefaultApi~deleteSavedLaneSavedLanesSavedLaneIdDeleteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete Saved Lane
     * @param {String} savedLaneId 
     * @param {module:api/DefaultApi~deleteSavedLaneSavedLanesSavedLaneIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     */
  }, {
    key: "deleteSavedLaneSavedLanesSavedLaneIdDelete",
    value: function deleteSavedLaneSavedLanesSavedLaneIdDelete(savedLaneId, callback) {
      var postBody = null;
      // verify the required parameter 'savedLaneId' is set
      if (savedLaneId === undefined || savedLaneId === null) {
        throw new Error("Missing the required parameter 'savedLaneId' when calling deleteSavedLaneSavedLanesSavedLaneIdDelete");
      }
      var pathParams = {
        'saved_lane_id': savedLaneId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/saved_lanes/{saved_lane_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getCustomerDatHistoricalRatesDatHistoricalGet operation.
     * @callback module:api/DefaultApi~getCustomerDatHistoricalRatesDatHistoricalGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DatResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Customer Dat Historical Rates
     * @param {module:model/EquipmentType} equipmentType 
     * @param {module:model/RateType} rateType 
     * @param {Array.<String>} stops List of stops in the format `country:US|state_province:TX|postal_code:78701`
     * @param {module:api/DefaultApi~getCustomerDatHistoricalRatesDatHistoricalGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DatResponse}
     */
  }, {
    key: "getCustomerDatHistoricalRatesDatHistoricalGet",
    value: function getCustomerDatHistoricalRatesDatHistoricalGet(equipmentType, rateType, stops, callback) {
      var postBody = null;
      // verify the required parameter 'equipmentType' is set
      if (equipmentType === undefined || equipmentType === null) {
        throw new Error("Missing the required parameter 'equipmentType' when calling getCustomerDatHistoricalRatesDatHistoricalGet");
      }
      // verify the required parameter 'rateType' is set
      if (rateType === undefined || rateType === null) {
        throw new Error("Missing the required parameter 'rateType' when calling getCustomerDatHistoricalRatesDatHistoricalGet");
      }
      // verify the required parameter 'stops' is set
      if (stops === undefined || stops === null) {
        throw new Error("Missing the required parameter 'stops' when calling getCustomerDatHistoricalRatesDatHistoricalGet");
      }
      var pathParams = {};
      var queryParams = {
        'equipment_type': equipmentType,
        'rate_type': rateType,
        'stops': this.apiClient.buildCollectionParam(stops, 'multi')
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DatResponse["default"];
      return this.apiClient.callApi('/dat/historical', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getCustomerDatRatesDatRatesGet operation.
     * @callback module:api/DefaultApi~getCustomerDatRatesDatRatesGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DatResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Customer Dat Rates
     * @param {module:model/EquipmentType} equipmentType 
     * @param {module:model/RateType} rateType 
     * @param {Array.<String>} stops List of stops in the format `country:US|state_province:TX|postal_code:78701`
     * @param {module:api/DefaultApi~getCustomerDatRatesDatRatesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DatResponse}
     */
  }, {
    key: "getCustomerDatRatesDatRatesGet",
    value: function getCustomerDatRatesDatRatesGet(equipmentType, rateType, stops, callback) {
      var postBody = null;
      // verify the required parameter 'equipmentType' is set
      if (equipmentType === undefined || equipmentType === null) {
        throw new Error("Missing the required parameter 'equipmentType' when calling getCustomerDatRatesDatRatesGet");
      }
      // verify the required parameter 'rateType' is set
      if (rateType === undefined || rateType === null) {
        throw new Error("Missing the required parameter 'rateType' when calling getCustomerDatRatesDatRatesGet");
      }
      // verify the required parameter 'stops' is set
      if (stops === undefined || stops === null) {
        throw new Error("Missing the required parameter 'stops' when calling getCustomerDatRatesDatRatesGet");
      }
      var pathParams = {};
      var queryParams = {
        'equipment_type': equipmentType,
        'rate_type': rateType,
        'stops': this.apiClient.buildCollectionParam(stops, 'multi')
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DatResponse["default"];
      return this.apiClient.callApi('/dat/rates', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the getSavedLanesSavedLanesGet operation.
     * @callback module:api/DefaultApi~getSavedLanesSavedLanesGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SavedLaneListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Saved Lanes
     * @param {Object} opts Optional parameters
     * @param {Number} [page = 1)] 
     * @param {Number} [limit = 50)] 
     * @param {module:api/DefaultApi~getSavedLanesSavedLanesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SavedLaneListResponse}
     */
  }, {
    key: "getSavedLanesSavedLanesGet",
    value: function getSavedLanesSavedLanesGet(opts, callback) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'page': opts['page'],
        'limit': opts['limit']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SavedLaneListResponse["default"];
      return this.apiClient.callApi('/saved_lanes', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the updateSavedLaneSavedLanesSavedLaneIdPut operation.
     * @callback module:api/DefaultApi~updateSavedLaneSavedLanesSavedLaneIdPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SavedLaneSchema} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update Saved Lane
     * @param {String} savedLaneId 
     * @param {module:model/SavedLaneSchema} savedLaneSchema 
     * @param {module:api/DefaultApi~updateSavedLaneSavedLanesSavedLaneIdPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SavedLaneSchema}
     */
  }, {
    key: "updateSavedLaneSavedLanesSavedLaneIdPut",
    value: function updateSavedLaneSavedLanesSavedLaneIdPut(savedLaneId, savedLaneSchema, callback) {
      var postBody = savedLaneSchema;
      // verify the required parameter 'savedLaneId' is set
      if (savedLaneId === undefined || savedLaneId === null) {
        throw new Error("Missing the required parameter 'savedLaneId' when calling updateSavedLaneSavedLanesSavedLaneIdPut");
      }
      // verify the required parameter 'savedLaneSchema' is set
      if (savedLaneSchema === undefined || savedLaneSchema === null) {
        throw new Error("Missing the required parameter 'savedLaneSchema' when calling updateSavedLaneSavedLanesSavedLaneIdPut");
      }
      var pathParams = {
        'saved_lane_id': savedLaneId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['APIKeyHeader'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _SavedLaneSchema["default"];
      return this.apiClient.callApi('/saved_lanes/{saved_lane_id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);
  return DefaultApi;
}();
exports["default"] = DefaultApi;